import { Injectable } from '@angular/core';
import { Observable, map, switchMap, take } from 'rxjs';
import { ApolloClientService } from './apollo-client.service';
import { GETALL_TAGS_QUERY } from 'src/app/graphQL/queries/tag-queries';
import { FDD_GET_ALL_TAGS_QUERY } from 'src/app/graphQL/queries/item-queries';
import { MigrationConfigService } from '../migration/migration-config.service';

@Injectable({
  providedIn: 'root',
})
export class TagsApiService {

  constructor(
    private apolloClientService: ApolloClientService,
    private migrationConfig: MigrationConfigService
  ) { }

  get(): Observable<string[]> {
    // Tag suggestions come from whichever API the rest of the app is reading, so the
    // dropdown can't offer tags that no longer exist in the store being displayed.
    //
    // This is mode-aware, matching ItemsService.getParentItems: `displaySource` is only
    // meaningful in `both`. Consulting it in every mode (as this did) meant `mode: 'new'`
    // fell back to the C# API, because displaySource defaults to 'old' — so tags came
    // from MSSQL while every item came from Postgres.
    return this.migrationConfig.getEntityConfig$('testCases').pipe(
      take(1),
      switchMap(config => {
        if (config.mode === 'old') return this.getFromOld();
        if (config.mode === 'new') return this.getFromGo();
        return config.displaySource === 'new' ? this.getFromGo() : this.getFromOld();
      })
    );
  }

  private getFromOld(): Observable<string[]> {
    return this.apolloClientService.apolloClient$.pipe(
      switchMap(client =>
        client.query<{configuratorAllTags: string[]}>({
          query: GETALL_TAGS_QUERY,
          variables: {}
        })
      ),
      map(results => results.data.configuratorAllTags ?? [])
    );
  }

  private getFromGo(): Observable<string[]> {
    return this.apolloClientService.fenixDomainDataClient$.pipe(
      switchMap(client =>
        client.query<{getAllTags: string[]}>({
          query: FDD_GET_ALL_TAGS_QUERY,
          fetchPolicy: 'no-cache'
        })
      ),
      map(results => results.data.getAllTags ?? [])
    );
  }
}
